import routes from '@routes';
import { fetchApi, CacheProps } from '../../fetch';

interface GetServiceDateProps extends CacheProps{
  userId: string
  serviceId: string
  locationId: string
}

const getServiceDate = ({ serviceId, userId, locationId, ...rest }: GetServiceDateProps) => {
  return fetchApi({
    method: 'POST',
    URL: routes['api.appointment.service-date'],
    payload: {
      user_id: userId,
      service_id: serviceId,
      location_id: locationId,
    },
    withToken: true,
    ...rest,
  });
};

export default getServiceDate;
